import React, { useState } from 'react';
import { useAuth } from '../components/AuthProvider';
import UsersManager from './views/UsersManager';
import ProfessionalsManager from './views/ProfessionalsManager';
import EventsManager from './views/EventsManager';
import EventRegistrationsManager from './views/EventRegistrationsManager';
import SendEmailManager from './views/SendEmailManager';
import DashboardManager from './views/DashboardManager';
import SiteStatisticsManager from './views/SiteStatisticsManager';
import AIManagerModule from './views/AIManagerModule';
import DocumentCreationManager from './views/DocumentCreationManager';
import AdminNavigation from './AdminNavigation';
import './style/admin.css';

const tabs = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'sitestatistics', label: 'Site Statistics' },
  { id: 'professionals', label: 'Professionals' },
  { id: 'users', label: 'Users' },
  { id: 'events', label: 'Events' },
  { id: 'registrations', label: 'Registrations' },
  { id: 'documents', label: 'Create Documents' },
  { id: 'email', label: 'Send Email' },
  { id: 'ai-manager', label: 'AI Manager' },
];

export default function AdminDashBoard() {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const [emailPrefill, setEmailPrefill] = useState(null);
  const { user } = useAuth();
  const currentTabLabel = tabs.find((tab) => tab.id === currentTab)?.label || 'Dashboard';

  const handleOpenEmail = (payload) => {
    setEmailPrefill(payload);
    setCurrentTab('email');
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <AdminNavigation tabs={tabs} currentTab={currentTab} onSelectTab={setCurrentTab} />
      </aside>

      <div className="admin-body-wrapper">
        <header className="admin-topbar">
          <div className="admin-topbar-heading">
            <span className="admin-topbar-kicker">Workspace</span>
            <span className="admin-topbar-divider">/</span>
            <strong>{currentTabLabel}</strong>
          </div>
          <div className="admin-topbar-account">
            <button type="button" className="admin-topbar-icon" aria-label="Help">?</button>
            <div className="admin-account-avatar">
              {user?.picture ? (
                <img src={user.picture} alt={user.name || 'Administrator'} referrerPolicy="no-referrer" />
              ) : (
                <span>{(user?.name || 'A').slice(0, 1).toUpperCase()}</span>
              )}
            </div>
            <div className="admin-account-copy">
              <strong>{user?.name || 'Administrator'}</strong>
              <span>{user?.email || user?.role || 'Admin'}</span>
            </div>
          </div>
        </header>
        <main className="admin-main-content">
          {currentTab === 'dashboard' && <DashboardManager />}
          {currentTab === 'sitestatistics' && <SiteStatisticsManager />}
          {currentTab === 'professionals' && <ProfessionalsManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'users' && <UsersManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'events' && <EventsManager />}
          {currentTab === 'registrations' && <EventRegistrationsManager onSendEmail={handleOpenEmail} />}
          {currentTab === 'documents' && <DocumentCreationManager />}
          {currentTab === 'email' && <SendEmailManager prefill={emailPrefill} />}
          {currentTab === 'ai-manager' && <AIManagerModule />}
        </main>
      </div>
    </div>
  );
}